import { useEffect } from 'react'
import {getListObjetives} from '../../../services/sKPI/objetive.service'


const useGetObjetives = (objetives, setObjetives) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListObjetives();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({
                        key: element.id,
                        text: `${element.name}`,
                        title:  `${element.name}`})
                });

                setObjetives(aux_array);
            }
            catch (error) {
                setObjetives([]);
            }
        }
        
        if (objetives === null) {
            getData()
        }
    }, [objetives, setObjetives]);
}

export {
    useGetObjetives
}